import { atom } from "recoil";

export const inviteUsersDataState = atom({
  key: "inviteUsersDataState",
  default: [],
});
